import { css } from "styled-components";

export const baseResetCSSWrapper = css`
  html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }
  body {
    margin: 0;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline;
  }
  audio:not([controls]) {
    display: none;
    height: 0;
  }
  [hidden],
  template {
    display: none;
  }
  a {
    background-color: transparent;
  }
  a:active,
  a:hover {
    outline: 0;
  }
  abbr[title] {
    border-bottom: 1px dotted;
  }
  b,
  strong {
    font-weight: 700;
  }
  dfn {
    font-style: italic;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  mark {
    background: #ff0;
    color: #000;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sup {
    top: -0.5em;
  }
  sub {
    bottom: -0.25em;
  }
  img {
    border: 0;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  figure {
    margin: 1em 40px;
  }
  hr {
    box-sizing: content-box;
    height: 0;
  }
  pre {
    overflow: auto;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }
  button {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  html input[type="button"],
  input[type="reset"],
  input[type="submit"] {
    -webkit-appearance: button;
    cursor: pointer;
  }
  button[disabled],
  html input[disabled] {
    cursor: default;
  }
  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  input {
    line-height: normal;
  }
  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    height: auto;
  }
  input[type="search"] {
    -webkit-appearance: textfield;
    box-sizing: content-box;
  }
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  fieldset {
    border: 1px solid silver;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }
  textarea {
    overflow: auto;
  }
  optgroup {
    font-weight: 700;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    padding: 0;
  }
  *,
  :after,
  :before {
    box-sizing: border-box;
  }
  html {
    font-size: 10px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  body {
    font-family: "UI Sans", "Lato", sans-serif;
    font-size: 15px;
    line-height: 1.7142857143;
    color: #494949;
    background-color: #fff;
  }
  button,
  input,
  select,
  textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  a {
    color: #494949;
    text-decoration: none;
  }

  @media (hover: hover) {
    a:hover, a:focus {
      color: #636363;
    }
  }

  a:focus,
  a:hover {
    /* TODO: Remove all text-decoration: none; */
    text-decoration: none;
  }
  a:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
  figure {
    margin: 0;
  }
  img {
    vertical-align: middle;
  }
  .img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
  }
  .img-rounded {
    border-radius: 0;
  }
  .img-thumbnail {
    padding: 4px;
    line-height: 1.7142857143;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 0;
    transition: all 0.2s ease-in-out;
    display: inline-block;
    max-width: 100%;
    height: auto;
  }
  .img-circle {
    border-radius: 50%;
  }
  hr {
    margin-top: 25px;
    margin-bottom: 25px;
    border: 0;
    border-top: 1px solid #eee;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  .sr-only-focusable:active,
  .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
  }
  [role="button"] {
    cursor: pointer;
  }
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: inherit;
    font-weight: 400;
    line-height: 1.1;
    color: inherit;
  }
  .h1 .small,
  .h1 small,
  .h2 .small,
  .h2 small,
  .h3 .small,
  .h3 small,
  .h4 .small,
  .h4 small,
  .h5 .small,
  .h5 small,
  .h6 .small,
  .h6 small,
  h1 .small,
  h1 small,
  h2 .small,
  h2 small,
  h3 .small,
  h3 small,
  h4 .small,
  h4 small,
  h5 .small,
  h5 small,
  h6 .small,
  h6 small {
    font-weight: 400;
    line-height: 1;
    color: #777;
  }
  .h1,
  .h2,
  .h3,
  h1,
  h2,
  h3 {
    margin-top: 25px;
    margin-bottom: 12.5px;
  }
  .h1 .small,
  .h1 small,
  .h2 .small,
  .h2 small,
  .h3 .small,
  .h3 small,
  h1 .small,
  h1 small,
  h2 .small,
  h2 small,
  h3 .small,
  h3 small {
    font-size: 65%;
  }
  .h4,
  .h5,
  .h6,
  h4,
  h5,
  h6 {
    margin-top: 12.5px;
    margin-bottom: 12.5px;
  }
  .h4 .small,
  .h4 small,
  .h5 .small,
  .h5 small,
  .h6 .small,
  .h6 small,
  h4 .small,
  h4 small,
  h5 .small,
  h5 small,
  h6 .small,
  h6 small {
    font-size: 75%;
  }
  .h1,
  h1 {
    font-size: 39px;
  }
  .h2,
  h2 {
    font-size: 32px;
  }
  .h3,
  h3 {
    font-size: 26px;
  }
  .h4,
  h4 {
    font-size: 19px;
  }
  .h5,
  h5 {
    font-size: 15px;
  }
  .h6,
  h6 {
    font-size: 13px;
  }
  p {
    margin: 0 0 12.5px;
  }
`;

export const baseTextCSSWrapper = css`
  .lead {
    margin-bottom: 25px;
    font-size: 17px;
    font-weight: 300;
    line-height: 1.4;
  }
  @media (min-width: 767px) {
    .lead {
      font-size: 22.5px;
    }
  }
  .small,
  small {
    font-size: 86%;
  }
  .mark,
  mark {
    background-color: #fcf8e3;
    padding: 0.2em;
  }
  .text-success {
    color: #3c763d;
  }
  a.text-success:focus,
  a.text-success:hover {
    color: #2b542c;
  }
  .text-info {
    color: #31708f;
  }
  a.text-info:focus,
  a.text-info:hover {
    color: #245269;
  }
  .text-warning {
    color: #8a6d3b;
  }
  a.text-warning:focus,
  a.text-warning:hover {
    color: #66512c;
  }
  .text-danger {
    color: #f80000;
  }
  a.text-danger:focus,
  a.text-danger:hover {
    color: #c50000;
  }
  .bg-primary {
    color: #fff;
    background-color: #337ab7;
  }
  a.bg-primary:focus,
  a.bg-primary:hover {
    background-color: #286090;
  }
  .bg-success {
    background-color: #dff0d8;
  }
  a.bg-success:focus,
  a.bg-success:hover {
    background-color: #c1e2b3;
  }
  .bg-info {
    background-color: #d9edf7;
  }
  a.bg-info:focus,
  a.bg-info:hover {
    background-color: #afd9ee;
  }
  .bg-warning {
    background-color: #fcf8e3;
  }
  a.bg-warning:focus,
  a.bg-warning:hover {
    background-color: #f7ecb5;
  }
  .bg-danger {
    background-color: #ffe6e7;
  }
  a.bg-danger:focus,
  a.bg-danger:hover {
    background-color: #ffb3b6;
  }
  .page-header {
    padding-bottom: 11.5px;
    margin: 50px 0 25px;
    border-bottom: 1px solid #eee;
  }
  ol,
  ul {
    margin-top: 0;
    margin-bottom: 12.5px;
  }
  ol ol,
  ol ul,
  ul ol,
  ul ul {
    margin-bottom: 0;
  }
  .list-inline,
  .list-unstyled {
    padding-left: 0;
    list-style: none;
  }
  .list-inline {
    margin-left: -5px;
  }
  .list-inline > li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
  }
  dl {
    margin-top: 0;
    margin-bottom: 25px;
  }
  dd,
  dt {
    line-height: 1.7142857143;
  }
  dt {
    font-weight: 700;
  }
  dd {
    margin-left: 0;
  }
  abbr[data-original-title],
  abbr[title] {
    cursor: help;
    border-bottom: 1px dotted #777;
  }
  address {
    margin-bottom: 25px;
    font-style: normal;
    line-height: 1.7142857143;
  }
`;

export const baseGridCSSWrapper = css`
  .container {
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
  .container:after,
  .container:before {
    content: " ";
    display: table;
  }
  .container:after {
    clear: both;
  }
  @media (min-width: 767px) {
    .container {
      width: 750px;
    }
  }
  @media (min-width: 992px) {
    .container {
      width: 970px;
    }
  }
  @media (min-width: 1200px) {
    .container {
      width: 1170px;
    }
  }
  .container-fluid {
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
  .container-fluid:after,
  .container-fluid:before {
    content: " ";
    display: table;
  }
  .container-fluid:after {
    clear: both;
  }
  .row {
    margin-left: -15px;
    margin-right: -15px;
  }
  .row:after,
  .row:before {
    content: " ";
    display: table;
  }
  .row:after {
    clear: both;
  }
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-13,
  .col-lg-14,
  .col-lg-15,
  .col-lg-16,
  .col-lg-17,
  .col-lg-18,
  .col-lg-19,
  .col-lg-20,
  .col-lg-21,
  .col-lg-22,
  .col-lg-23,
  .col-lg-24,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-13,
  .col-md-14,
  .col-md-15,
  .col-md-16,
  .col-md-17,
  .col-md-18,
  .col-md-19,
  .col-md-20,
  .col-md-21,
  .col-md-22,
  .col-md-23,
  .col-md-24,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-13,
  .col-sm-14,
  .col-sm-15,
  .col-sm-16,
  .col-sm-17,
  .col-sm-18,
  .col-sm-19,
  .col-sm-20,
  .col-sm-21,
  .col-sm-22,
  .col-sm-23,
  .col-sm-24,
  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12,
  .col-xs-13,
  .col-xs-14,
  .col-xs-15,
  .col-xs-16,
  .col-xs-17,
  .col-xs-18,
  .col-xs-19,
  .col-xs-20,
  .col-xs-21,
  .col-xs-22,
  .col-xs-23,
  .col-xs-24 {
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12,
  .col-xs-13,
  .col-xs-14,
  .col-xs-15,
  .col-xs-16,
  .col-xs-17,
  .col-xs-18,
  .col-xs-19,
  .col-xs-20,
  .col-xs-21,
  .col-xs-22,
  .col-xs-23,
  .col-xs-24 {
    float: left;
  }
  .col-xs-1 {
    width: 4.1666666667%;
  }
  .col-xs-2 {
    width: 8.3333333333%;
  }
  .col-xs-3 {
    width: 12.5%;
  }
  .col-xs-4 {
    width: 16.6666666667%;
  }
  .col-xs-5 {
    width: 20.8333333333%;
  }
  .col-xs-6 {
    width: 25%;
  }
  .col-xs-7 {
    width: 29.1666666667%;
  }
  .col-xs-8 {
    width: 33.3333333333%;
  }
  .col-xs-9 {
    width: 37.5%;
  }
  .col-xs-10 {
    width: 41.6666666667%;
  }
  .col-xs-11 {
    width: 45.8333333333%;
  }
  .col-xs-12 {
    width: 50%;
  }
  .col-xs-13 {
    width: 54.1666666667%;
  }
  .col-xs-14 {
    width: 58.3333333333%;
  }
  .col-xs-15 {
    width: 62.5%;
  }
  .col-xs-16 {
    width: 66.6666666667%;
  }
  .col-xs-17 {
    width: 70.8333333333%;
  }
  .col-xs-18 {
    width: 75%;
  }
  .col-xs-19 {
    width: 79.1666666667%;
  }
  .col-xs-20 {
    width: 83.3333333333%;
  }
  .col-xs-21 {
    width: 87.5%;
  }
  .col-xs-22 {
    width: 91.6666666667%;
  }
  .col-xs-23 {
    width: 95.8333333333%;
  }
  .col-xs-24 {
    width: 100%;
  }
  @media (min-width: 767px) {
    .col-sm-1,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12,
    .col-sm-13,
    .col-sm-14,
    .col-sm-15,
    .col-sm-16,
    .col-sm-17,
    .col-sm-18,
    .col-sm-19,
    .col-sm-20,
    .col-sm-21,
    .col-sm-22,
    .col-sm-23,
    .col-sm-24 {
      float: left;
    }
    .col-sm-1 {
      width: 4.1666666667%;
    }
    .col-sm-2 {
      width: 8.3333333333%;
    }
    .col-sm-3 {
      width: 12.5%;
    }
    .col-sm-4 {
      width: 16.6666666667%;
    }
    .col-sm-5 {
      width: 20.8333333333%;
    }
    .col-sm-6 {
      width: 25%;
    }
    .col-sm-7 {
      width: 29.1666666667%;
    }
    .col-sm-8 {
      width: 33.3333333333%;
    }
    .col-sm-9 {
      width: 37.5%;
    }
    .col-sm-10 {
      width: 41.6666666667%;
    }
    .col-sm-11 {
      width: 45.8333333333%;
    }
    .col-sm-12 {
      width: 50%;
    }
    .col-sm-13 {
      width: 54.1666666667%;
    }
    .col-sm-14 {
      width: 58.3333333333%;
    }
    .col-sm-15 {
      width: 62.5%;
    }
    .col-sm-16 {
      width: 66.6666666667%;
    }
    .col-sm-17 {
      width: 70.8333333333%;
    }
    .col-sm-18 {
      width: 75%;
    }
    .col-sm-19 {
      width: 79.1666666667%;
    }
    .col-sm-20 {
      width: 83.3333333333%;
    }
    .col-sm-21 {
      width: 87.5%;
    }
    .col-sm-22 {
      width: 91.6666666667%;
    }
    .col-sm-23 {
      width: 95.8333333333%;
    }
    .col-sm-24 {
      width: 100%;
    }
  }
  @media (min-width: 992px) {
    .col-md-1,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-10,
    .col-md-11,
    .col-md-12,
    .col-md-13,
    .col-md-14,
    .col-md-15,
    .col-md-16,
    .col-md-17,
    .col-md-18,
    .col-md-19,
    .col-md-20,
    .col-md-21,
    .col-md-22,
    .col-md-23,
    .col-md-24 {
      float: left;
    }
    .col-md-1 {
      width: 4.1666666667%;
    }
    .col-md-2 {
      width: 8.3333333333%;
    }
    .col-md-3 {
      width: 12.5%;
    }
    .col-md-4 {
      width: 16.6666666667%;
    }
    .col-md-5 {
      width: 20.8333333333%;
    }
    .col-md-6 {
      width: 25%;
    }
    .col-md-7 {
      width: 29.1666666667%;
    }
    .col-md-8 {
      width: 33.3333333333%;
    }
    .col-md-9 {
      width: 37.5%;
    }
    .col-md-10 {
      width: 41.6666666667%;
    }
    .col-md-11 {
      width: 45.8333333333%;
    }
    .col-md-12 {
      width: 50%;
    }
    .col-md-13 {
      width: 54.1666666667%;
    }
    .col-md-14 {
      width: 58.3333333333%;
    }
    .col-md-15 {
      width: 62.5%;
    }
    .col-md-16 {
      width: 66.6666666667%;
    }
    .col-md-17 {
      width: 70.8333333333%;
    }
    .col-md-18 {
      width: 75%;
    }
    .col-md-19 {
      width: 79.1666666667%;
    }
    .col-md-20 {
      width: 83.3333333333%;
    }
    .col-md-21 {
      width: 87.5%;
    }
    .col-md-22 {
      width: 91.6666666667%;
    }
    .col-md-23 {
      width: 95.8333333333%;
    }
    .col-md-24 {
      width: 100%;
    }
  }
  @media (min-width: 1200px) {
    .col-lg-1,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12,
    .col-lg-13,
    .col-lg-14,
    .col-lg-15,
    .col-lg-16,
    .col-lg-17,
    .col-lg-18,
    .col-lg-19,
    .col-lg-20,
    .col-lg-21,
    .col-lg-22,
    .col-lg-23,
    .col-lg-24 {
      float: left;
    }
    .col-lg-1 {
      width: 4.1666666667%;
    }
    .col-lg-2 {
      width: 8.3333333333%;
    }
    .col-lg-3 {
      width: 12.5%;
    }
    .col-lg-4 {
      width: 16.6666666667%;
    }
    .col-lg-5 {
      width: 20.8333333333%;
    }
    .col-lg-6 {
      width: 25%;
    }
    .col-lg-7 {
      width: 29.1666666667%;
    }
    .col-lg-8 {
      width: 33.3333333333%;
    }
    .col-lg-9 {
      width: 37.5%;
    }
    .col-lg-10 {
      width: 41.6666666667%;
    }
    .col-lg-11 {
      width: 45.8333333333%;
    }
    .col-lg-12 {
      width: 50%;
    }
    .col-lg-13 {
      width: 54.1666666667%;
    }
    .col-lg-14 {
      width: 58.3333333333%;
    }
    .col-lg-15 {
      width: 62.5%;
    }
    .col-lg-16 {
      width: 66.6666666667%;
    }
    .col-lg-17 {
      width: 70.8333333333%;
    }
    .col-lg-18 {
      width: 75%;
    }
    .col-lg-19 {
      width: 79.1666666667%;
    }
    .col-lg-20 {
      width: 83.3333333333%;
    }
    .col-lg-21 {
      width: 87.5%;
    }
    .col-lg-22 {
      width: 91.6666666667%;
    }
    .col-lg-23 {
      width: 95.8333333333%;
    }
    .col-lg-24 {
      width: 100%;
    }
  }
`;

export const baseFormCSSWrapper = css`
  fieldset {
    margin: 0;
    min-width: 0;
  }
  fieldset,
  legend {
    padding: 0;
    border: 0;
  }
  legend {
    display: block;
    width: 100%;
    margin-bottom: 25px;
    font-size: 22.5px;
    line-height: inherit;
    color: #333;
    border-bottom: 1px solid #e5e5e5;
  }
  label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 700;
  }
  input[type="search"] {
    box-sizing: border-box;
  }
  input[type="checkbox"],
  input[type="radio"] {
    margin: 4px 0 0;
    line-height: normal;
  }
  input[type="file"] {
    display: block;
  }
  input[type="range"] {
    display: block;
    width: 100%;
  }
  select[multiple],
  select[size] {
    height: auto;
  }
  input[type="checkbox"]:focus,
  input[type="file"]:focus,
  input[type="radio"]:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
`;

export const baseSupplementalCSSWrapper = css`
  .clearfix:after,
  .clearfix:before {
    content: " ";
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .center-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .pull-right {
    float: right !important;
  }
  .pull-left {
    float: left !important;
  }
  .hide {
    display: none !important;
  }
  .show {
    display: block !important;
  }
  .invisible {
    visibility: hidden;
  }
  .text-hide {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
  }
  .hidden {
    display: none !important;
  }
  .affix {
    position: fixed;
  }
  @-ms-viewport {
    width: device-width;
  }
  @media (max-width: 766px) {
    .hidden-xs {
      display: none !important;
    }
  }
  @media (min-width: 767px) and (max-width: 991px) {
    .hidden-sm {
      display: none !important;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .hidden-md {
      display: none !important;
    }
  }
  @media (min-width: 1200px) {
    .hidden-lg {
      display: none !important;
    }
  }
  .visible-print {
    display: none !important;
  }
  @media print {
    .visible-print {
      display: block !important;
    }
    table.visible-print {
      display: table !important;
    }
    tr.visible-print {
      display: table-row !important;
    }
    td.visible-print,
    th.visible-print {
      display: table-cell !important;
    }
  }
  .visible-print-block {
    display: none !important;
  }
  @media print {
    .visible-print-block {
      display: block !important;
    }
  }
  .visible-print-inline {
    display: none !important;
  }
  @media print {
    .visible-print-inline {
      display: inline !important;
    }
  }
  .visible-print-inline-block {
    display: none !important;
  }
  @media print {
    .visible-print-inline-block {
      display: inline-block !important;
    }
  }
  @media print {
    .hidden-print {
      display: none !important;
    }
  }
`;
